export default __webpack_public_path__ + "static/media/046-high-voltage.0b48fe3e.png";